import { render } from "./EditPriceModal.vue?vue&type=template&id=35249d26&scoped=true&ts=true&lang=pug"
import script from "./EditPriceModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditPriceModal.vue?vue&type=script&lang=ts&setup=true"

import "./EditPriceModal.vue?vue&type=style&index=0&id=35249d26&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35249d26"]])

export default __exports__